import React from 'react';
import { ProposalResolution } from '../../models/clinicAgent';
import { proposalTitle } from '../../services/clinicAgentProposals';

interface ProposalResolutionCardProps {
  resolution: ProposalResolution;
}

// A read-only "event" card for a proposal that was already resolved — rendered
// from server state (proposal_resolved broadcast / proposal_resolution history
// rows), not from local optimistic state. Distinct from ProposalCard, which is
// the interactive pending proposal.
const ProposalResolutionCard: React.FC<ProposalResolutionCardProps> = ({ resolution }) => {
  const applied = resolution.status !== 'discarded';
  const accent = applied ? '#059669' : '#9ca3af';
  const label = applied ? '✓ Aplicado' : 'Descartado';

  return (
    <div
      style={{
        alignSelf: 'stretch',
        border: '1px solid #e5e7eb',
        borderLeft: `3px solid ${accent}`,
        borderRadius: 10,
        background: '#f9fafb',
        padding: '8px 12px',
        margin: '2px 0',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: accent }}>{label}</span>
        <span style={{ fontSize: 12, color: '#6b7280' }}>
          {proposalTitle(resolution.action)}
        </span>
      </div>
      {resolution.summary && (
        <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>{resolution.summary}</div>
      )}
    </div>
  );
};

export default ProposalResolutionCard;
